import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_APP_ENV || "local";

let initialized = false;

export function isFirstPartySentryHost(hostname: string): boolean {
	return hostname === "firmindex.cz" || hostname.endsWith(".firmindex.cz");
}

export function initSentry() {
	if (initialized || !dsn || typeof window === "undefined") return;
	// Security scanners sometimes mirror the production bundle under their own
	// domain. Do not let those foreign DOM/hydration errors pollute our project.
	if (environment === "production" && !isFirstPartySentryHost(window.location.hostname)) return;

	Sentry.init({
		dsn,
		environment,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracesSampleRate: environment === "production" ? 0.1 : 1.0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
		ignoreErrors: [/Lock .*another request/i],
	});

	initialized = true;
}

export { Sentry };
